import { conditionFilter } from "@@/shared/discounts/conditions/discount-condition-filter";
import type { OrderItem } from "@@/shared/orders/order-items/order-item";
import { zeroPrice } from "@@/shared/prices/price";
import { subtractFromPrice } from "@@/shared/prices/subtract-from-price";
import { sumPrices } from "@@/shared/prices/sum-prices";
import type { DiscountCalculator } from "../discount-calculator-type";
import type { ValueDiscount } from "./value-discount";

const valueDiscountCalculator: DiscountCalculator<ValueDiscount> =
    (discount: ValueDiscount) => (items: OrderItem[]) => {
        const entitledItems = conditionFilter(discount, items);
        if (!entitledItems.length) return zeroPrice;
        // Calculate discount price
        const discountPrice = subtractFromPrice(
            sumPrices(entitledItems.map(item => item.price)),
            [discount.value],
        );
        return discountPrice;
    };

const valueDiscountCalculatorOrderItem =
    (discount: ValueDiscount) => (item: OrderItem) => {
        const entitledItems = conditionFilter(discount, [item]);
        if (entitledItems.length !== 1) return item.price;

        // Calculate discount price
        const discountPrice = subtractFromPrice(item.price, [discount.value]);

        return discountPrice;
    };

export { valueDiscountCalculator, valueDiscountCalculatorOrderItem };
